module.exports = __webpack_public_path__ + "img/68.22f7ada0.png";